// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i7T4uy {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: var(--radius-s);
  position: relative;
  min-height: 0;
  overflow: hidden;
}

.AFDDcM {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: var(--spacing-3);
}

.d2iapD {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--spacing-1);
}

.hSdvw1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--spacing-3);
}

.E8stTp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1);
}

.NkNoFB {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--spacing-0-5);
}

.Bdn2b3 {
  height: 72px;
  width: 72px;
}

.BB2AKP {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.y8PqVl {
  display: flex;
  flex: 1;
  width: 100%;
  padding: var(--spacing-3);
}

.OCC8cd {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: var(--spacing-3);
  position: relative;
  min-height: 0;
  overflow: hidden;
}

.kXz4o0 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-3);
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.efWSzY {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1);
  flex: 1;
  min-height: 0;
  padding-right: var(--spacing-0-5);
}

.MA2upu {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-1-5);
}

.nnD8_U {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: var(--spacing-1-5);
}

.OOveUB {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-1-5);
}

.usXi_M {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.kUtM2z {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.nqC8R9 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.h3SbBn {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.Oudy32 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--status-error);
}

.zi5iZU {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
}

.D4gUBa {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.nwL4hB {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  margin-top: 2px;
}

.R727Mv {
  min-width: 100px;
}

.Aro7Fu {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 74px;
  gap: var(--spacing-2);
  padding-left: var(--spacing-2);
  padding-right: var(--spacing-2);
  border-radius: var(--radius-s);
  background-color: var(--surface-neutral-pale);
}

.Qfx64V {
  opacity: 0.6;
}

.WAtRce {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  gap: var(--spacing-2);
}

.fV7pnL {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  margin-top: 2px;
}

.udLV2e {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
}

.udLV2e:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.JRbicQ {
  height: 16px;
  width: 16px;
}

.mWCOzC {
  width: 100%;
}

.Y8tn2f {
  width: 100%;
  height: 1px;
  background-color: var(--surface-neutral-soft);
  margin: 0;
  padding: 0;
}

.wFwmrU {
  height: 16px;
  width: 16px;
}

.g6EeJU {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
}

.Sl5WxK {
  height: 24px;
  width: 24px;
}

.GYQxS3 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--brand-tr-orange);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/pages/PixEmployeeAccountPayable/PixEmployeeAccountPayable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6CAA6C;EAC7C,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,6BAA6B;AAC/B","sourcesContent":[".main {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n  border-radius: var(--radius-s);\n  position: relative;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.fullCenterColumn {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  gap: var(--spacing-3);\n}\n\n.smallGapCenterColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.centerColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: var(--spacing-3);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.bigIcon {\n  height: 72px;\n  width: 72px;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.body {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  padding: var(--spacing-3);\n}\n\n.step {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  gap: var(--spacing-3);\n  position: relative;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.stepContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-3);\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.stepList {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1);\n  flex: 1;\n  min-height: 0;\n  padding-right: var(--spacing-0-5);\n}\n\n.stepFooter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-1-5);\n}\n\n.stepRowBetween {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: var(--spacing-1-5);\n}\n\n.stepRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: var(--spacing-1-5);\n}\n\n.mediumSemiboldText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.largeSemiboldText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.mediumRegularText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.largeRegularText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.mediumRegularRedText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-error);\n}\n\n.mediumRegularNeutralText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n}\n\n.extraLargeSemiboldText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.mediumRegularStrongerText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  margin-top: 2px;\n}\n\n.button {\n  min-width: 100px;\n}\n\n.accountPayable {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 74px;\n  gap: var(--spacing-2);\n  padding-left: var(--spacing-2);\n  padding-right: var(--spacing-2);\n  border-radius: var(--radius-s);\n  background-color: var(--surface-neutral-pale);\n}\n\n.accountPayableDisabled {\n  opacity: 0.6;\n}\n\n.accountPayableRow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 100%;\n  gap: var(--spacing-2);\n}\n\n.accountPayableColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  height: 100%;\n  margin-top: 2px;\n}\n\n.accountPayableButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.accountPayableButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.accountPayableIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.alert {\n  width: 100%;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--surface-neutral-soft);\n  margin: 0;\n  padding: 0;\n}\n\n.calendarIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.calendarButton {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.smallIcon {\n  height: 24px;\n  width: 24px;\n}\n\n.mediumRegularOrangeText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--brand-tr-orange);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `i7T4uy`,
	"fullCenterColumn": `AFDDcM`,
	"smallGapCenterColumn": `d2iapD`,
	"centerColumn": `hSdvw1`,
	"column": `E8stTp`,
	"row": `NkNoFB`,
	"bigIcon": `Bdn2b3`,
	"header": `BB2AKP`,
	"body": `y8PqVl`,
	"step": `OCC8cd`,
	"stepContent": `kXz4o0`,
	"stepList": `efWSzY`,
	"stepFooter": `MA2upu`,
	"stepRowBetween": `nnD8_U`,
	"stepRow": `OOveUB`,
	"mediumSemiboldText": `usXi_M`,
	"largeSemiboldText": `kUtM2z`,
	"mediumRegularText": `nqC8R9`,
	"largeRegularText": `h3SbBn`,
	"mediumRegularRedText": `Oudy32`,
	"mediumRegularNeutralText": `zi5iZU`,
	"extraLargeSemiboldText": `D4gUBa`,
	"mediumRegularStrongerText": `nwL4hB`,
	"button": `R727Mv`,
	"accountPayable": `Aro7Fu`,
	"accountPayableDisabled": `Qfx64V`,
	"accountPayableRow": `WAtRce`,
	"accountPayableColumn": `fV7pnL`,
	"accountPayableButton": `udLV2e`,
	"accountPayableIcon": `JRbicQ`,
	"alert": `mWCOzC`,
	"divider": `Y8tn2f`,
	"calendarIcon": `wFwmrU`,
	"calendarButton": `g6EeJU`,
	"smallIcon": `Sl5WxK`,
	"mediumRegularOrangeText": `GYQxS3`
};
module.exports = ___CSS_LOADER_EXPORT___;
